import { useEffect, useState, useContext } from "react";
import axios from "axios";
import Context from "../context/Context";
export default function usePageImageGalleryScroll(
  pageNumber,
  token,
  campaignId,
  contestId,
  organiserId,
  guestModeEnabled,
  campaignMetaData,
  viewMore,
  likeMap,
  setLikeMap,
  initialRender,
  setInitialRender,
  contestDetails
) {
  const {
    contestImageGalleryContents,
    setContestImageGalleryContents,
    hasMore,
    setHasMore,
    setPageNumber,
    setViewMore,
  } = useContext(Context);
  const [dataloading, setDataLoading] = useState(true);
  const [error, setError] = useState(false);

  useEffect(() => {
    if (contestDetails?.contestType == "SERIES") {
      setDataLoading(false);
      return;
    }
    if (
      contestImageGalleryContents &&
      contestImageGalleryContents[0] &&
      contestImageGalleryContents[0]?.contestId !== contestId
    ) {
      setContestImageGalleryContents([]);
      setPageNumber(2);
      setViewMore(false);
    }
    if (initialRender) {
      setInitialRender(false);
      return;
    }
    let limit = contestDetails?.entriesToDisplay || 48;
    if (contestImageGalleryContents?.length / limit >= pageNumber) {
      setHasMore(true);
      setDataLoading(false);
      return;
    }
    if (contestId && campaignId) {
      setDataLoading(true);
      setError(false);
      const updatedLikeMap = new Map(likeMap);
      let cancel;
      let url = "";
      let type = contestDetails?.contestType.startsWith("QUIZ") ? "QUIZ" : "";
      if (guestModeEnabled || !viewMore) {
        url = `${process.env.REACT_APP_CONTEST_ENTRIES}/${organiserId}/${campaignId}/${contestId}?page=1&limit=${limit}&type=${type}`;
      } else {
        url = `${process.env.REACT_APP_CONTEST_ENTRIES}/${organiserId}/${campaignId}/${contestId}?page=${pageNumber}&limit=${limit}&type=${type}`;
      }
      axios({
        method: "get",
        url: url,
        cancelToken: new axios.CancelToken((c) => (cancel = c)),
      })
        .then((res) => {
          let entris = res.data.data;
          entris.forEach((item) => {
            if (updatedLikeMap.has("con" + item?._id)) {
              const obj = updatedLikeMap.get("con" + item?._id);
              let count = item?.likesCount ? item?.likesCount : 0;
              obj.likesCount = obj.likesCount ? obj.likesCount : count;
              updatedLikeMap.set("con" + item?._id, obj);
            } else {
              updatedLikeMap.set("con" + item?._id, {
                likesCount: item?.likesCount ? item?.likesCount : 0,
              });
            }
          });
          setLikeMap(updatedLikeMap);
          if (guestModeEnabled || !viewMore) {
            setContestImageGalleryContents(res.data.data);
            setHasMore(false);
          } else {
            setContestImageGalleryContents((prevContestData) => {
              return [...new Set([...prevContestData, ...res.data.data])];
            });
            setHasMore(res.data.data.length > 0);
          }
          setDataLoading(false);
        })
        .catch((e) => {
          if (axios.isCancel(e)) return;
          setError(true);
          setDataLoading(false);
        });

      return () => cancel();
    }
  }, [organiserId, contestId, campaignId, pageNumber, viewMore]);

  return { dataloading, error, contestImageGalleryContents, hasMore };
}
